import { api } from '$shared/api/index';
import { userStore } from '$shared/stores/user';
import type User from '$shared/models/User';
import { withServiceErrorHandling } from '$shared/helpers/decorators/ServiceErrorWrapper';
import type { Role } from '$shared/constants/Role';
import type UserRole from '$shared/models/UserRole';

class UserService {
  private users: Array<User>;

  async getUsersAsync(): Promise<Array<User>> {
    return withServiceErrorHandling('getUsersAsync', async () => {
      if (this.users) {
        return this.users;
      }
      this.users = await api.getUsersAsync();
      return this.users;
    })();
  }

  public async loadCredUsersAsync(): Promise<void> {
    return withServiceErrorHandling('loadCredUsersAsync', async () => {
      const users: User[] = await api.getCredUsersAsync();
      userStore.setCredUsers(users);
    })();
  }

  public async getUserRoleByRoleAsync(role: Role | undefined): Promise<UserRole | undefined> {
    return withServiceErrorHandling('getUserRoleByRoleAsync', async () => {
      if (!role) return;
      return await api.getOrganizationRoleAsync(role);
    })();
  }
}

export default new UserService();
